import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

export const TermsOfService = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-2">Terms of Service</h1>
            <p className="text-sm text-gray-600 mb-8">Last Updated: November 27, 2025</p>

            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                <p className="text-gray-700 mb-4">
                  By accessing and using NetAuctions.Inc ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these Terms of Service, please do not use our Service.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Description of Service</h2>
                <p className="text-gray-700 mb-4">
                  NetAuctions.Inc provides:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-4">
                  <li>An online directory of auction companies and licensed auctioneers</li>
                  <li>Search and discovery tools for finding auction services</li>
                  <li>Quote request and communication facilitation between clients and auctioneers</li>
                  <li>Premier listing services for featured placement</li>
                  <li>AI-powered auction website development services</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. User Accounts and Registration</h2>
                <p className="text-gray-700 mb-4">
                  <strong>3.1 Account Creation:</strong> Auctioneers may claim or request listings by providing accurate, complete information including license number, contact details, and professional credentials.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>3.2 Account Security:</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>3.3 License Verification:</strong> We reserve the right to verify auctioneer licenses with state licensing boards. Providing false licensing information may result in immediate account termination.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Listing Requirements and Content</h2>
                <p className="text-gray-700 mb-4">
                  <strong>4.1 Accuracy:</strong> All listings must contain accurate, current information. Users must update their listings promptly when information changes.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>4.2 Prohibited Content:</strong> Listings may not contain:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-4">
                  <li>False, misleading, or deceptive information</li>
                  <li>Unlicensed auction services or illegal activities</li>
                  <li>Offensive, discriminatory, or inappropriate content</li>
                  <li>Spam, malware, or malicious links</li>
                  <li>Content that infringes on intellectual property rights</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Premier Listing Services</h2>
                <p className="text-gray-700 mb-4">
                  <strong>5.1 Subscription:</strong> Premier listings are offered on an annual subscription basis at $59.88/year (equivalent to $4.99/month).
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>5.2 Benefits:</strong> Premier members receive priority placement in search results, enhanced profile features, logo and video display, and featured placement in regional ads.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>5.3 Payment and Renewal:</strong> Subscriptions automatically renew annually unless cancelled. Refunds are provided on a pro-rata basis for unused portions of the subscription period.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>5.4 Cancellation:</strong> You may cancel your Premier subscription at any time through your account dashboard or by contacting support.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Quote Requests and Communication</h2>
                <p className="text-gray-700 mb-4">
                  <strong>6.1 Facilitation Only:</strong> NetAuctions.Inc facilitates communication between clients and auctioneers but is not a party to any agreements or transactions between them.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>6.2 No Endorsement:</strong> Inclusion in our directory does not constitute an endorsement or recommendation. Users should conduct their own due diligence.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>6.3 Response Times:</strong> Auctioneers are encouraged to respond to quote requests within 48 hours but are not obligated to accept all requests.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Prohibited Activities</h2>
                <p className="text-gray-700 mb-4">Users may not:</p>
                <ul className="list-disc pl-6 text-gray-700 mb-4">
                  <li>Use automated systems to scrape or collect data from the Service</li>
                  <li>Attempt to gain unauthorized access to any portion of the Service</li>
                  <li>Interfere with or disrupt the Service or servers</li>
                  <li>Impersonate another person or entity</li>
                  <li>Use the Service for any illegal purposes</li>
                  <li>Harass, abuse, or harm other users</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Intellectual Property</h2>
                <p className="text-gray-700 mb-4">
                  <strong>8.1 Our Content:</strong> The Service and its original content, features, and functionality are owned by NetAuctions Inc. and are protected by international copyright, trademark, and other intellectual property laws.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>8.2 User Content:</strong> By submitting content (logos, videos, descriptions), you grant us a worldwide, non-exclusive, royalty-free license to use, display, and distribute such content in connection with the Service.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Disclaimer of Warranties</h2>
                <p className="text-gray-700 mb-4">
                  THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. We do not warrant that:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-4">
                  <li>The Service will be uninterrupted or error-free</li>
                  <li>All information in listings is accurate or complete</li>
                  <li>The Service will meet your specific requirements</li>
                  <li>Any defects will be corrected</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Limitation of Liability</h2>
                <p className="text-gray-700 mb-4">
                  TO THE MAXIMUM EXTENT PERMITTED BY LAW, NetAuctions Inc. SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, OR OTHER INTANGIBLE LOSSES.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Indemnification</h2>
                <p className="text-gray-700 mb-4">
                  You agree to indemnify and hold NetAuctions Inc., its officers, directors, employees, and agents harmless from any claims, damages, losses, liabilities, and expenses (including attorneys' fees) arising from your use of the Service or violation of these Terms.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Termination</h2>
                <p className="text-gray-700 mb-4">
                  We may terminate or suspend your account and access to the Service immediately, without prior notice, for any reason, including breach of these Terms. Upon termination, your right to use the Service will immediately cease.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Changes to Terms</h2>
                <p className="text-gray-700 mb-4">
                  We reserve the right to modify these Terms at any time. We will notify users of material changes via email or prominent notice on the Service. Continued use of the Service after changes constitutes acceptance of the modified Terms.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Governing Law</h2>
                <p className="text-gray-700 mb-4">
                  These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">15. Contact Information</h2>
                <p className="text-gray-700 mb-4">
                  For questions about these Terms, please contact us at:
                </p>
                <p className="text-gray-700">
                  <strong>Email:</strong> admin@net-auctions.com<br />
                  <strong>Website:</strong> NetAuctions.Inc
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
